import { useCallback } from 'react';

import { type Clip, type Tag, type UnmadeTag } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackAddedAssetsTagsParams = {
  assets: Clip['id'][];
  tags: (Tag | UnmadeTag)[];
  location: AirActionTrackingLocation;
  selectAll?: boolean;
};

export const useTrackAddedTagsToAssets = () => {
  const { track } = useAnalyticsUtilities();

  const trackAddedTagsToAssets = useCallback(
    (params: TrackAddedAssetsTagsParams) => {
      track(`Added tags to assets`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackAddedTagsToAssets };
};
